import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {Observable} from 'rxjs';
import {ActivityStatus, IActivity} from "../activities/activity";
import {Website} from "../websites/website/website";
import {Config} from "../config/config";
import {DashboardUtils} from "../shared/utils/dashboard-utils";
import {BuilderTemplates} from "../websites/website/builder-templates/builder-templates";
import {ActivityNotificationAction} from "../activity-notifications/activity-notification";


@Component({
    selector: 'db-ghost-waiting',
    templateUrl: './ghost-waiting.component.html',
    styleUrls: ['./ghost-waiting.component.scss'],
    standalone: false
})
export class GhostWaitingComponent implements OnInit {

  public ongoingBuilderActivity$: Observable<IActivity>;
  public ongoingActivities$: Observable<IActivity[]>;
  public loading: boolean;
  public websiteId: number;
  public templateId: number;
  public website: Website;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>
  ) {}

  ngOnInit() {
    const queryParams: any = (<any>this._route.queryParams).value;
    this.websiteId = parseInt(queryParams.websiteId, 10);
    this.templateId =  queryParams.templateId ? parseInt(queryParams.templateId, 10) : null;
    this._store.select(fromStore.getWebsite(this.websiteId)).subscribe((website: Website) => {
      this.website = website;
    });

    if (this.website && this.website.id) {
      this._store.select(fromStore.getLastBuilderTemplate(this.websiteId)).subscribe((builderTemplate: BuilderTemplates) => {
        if (builderTemplate && builderTemplate.id && this.website.adminElementorUrl) {
          window.location.href = DashboardUtils.generateWpAdminRedirectorUrl(this.websiteId, this.website.adminElementorUrl);
        }
      });
    }

    this.ongoingBuilderActivity$ = this._store.select(fromStore.getBuilderOngoingActivity(this.websiteId, Config.builderPluginSlug, !!this.website.domain_hash));

    if (this.website && this.website.id && this.website.adminElementorUrl) {
      this.ongoingBuilderActivity$.subscribe((activity) => {
        if (activity) {
          if (activity.status === 'done') {
            window.location.href = DashboardUtils.generateWpAdminRedirectorUrl(this.websiteId, this.website.adminElementorUrl);
          } else if (activity.status === 'failed') {
            this._router.navigate(["/websites/"]);
          } else {
            this.loading = true;
          }
        }
      });
    }
    this.ongoingActivities$ = this._store.select(fromStore.getOngoingActivities);
    this.ongoingActivities$
      .subscribe((data): void => {
        if (data) {
          const ongoingActivitiesDone = data.filter((activity): any => activity && (activity.action === ActivityNotificationAction.CREATE_WEBSITE || activity.action === ActivityNotificationAction.ADD_WEBSITE) && activity.status === ActivityStatus.DONE);
          const ongoingActivitiesFailed = data.filter((activity): any => activity && (activity.action === ActivityNotificationAction.CREATE_WEBSITE || activity.action === ActivityNotificationAction.ADD_WEBSITE) && activity.status === ActivityStatus.FAILED);
          if (ongoingActivitiesDone.length) {
            this._router.navigate(["/websites/"]);
          }
          if (ongoingActivitiesFailed.length) {
            this._router.navigate(["/websites/"]);
          }
        }
      });
  }

}
